module.exports = __webpack_public_path__ + "img/button_default_02.00673b7f.png";